import { TransferChannelType } from "@/common/types/transfer";

export interface TransferToIvrProps {
	closePopover: () => void;
	channelType?: TransferChannelType;
	messagingId?: string;
	onTransferCallback?: () => void;
}

export enum TransferDestinationType {
	None = 0,
	Agent = 1,
	Queue = 2,
	Flow = 3,
}

export interface TransferDestination {
	id: string;
	name: string;
	type: TransferDestinationType;
}

export interface TransferToIvrRequest {
	targetId: string;
	targetName: string;
	type: TransferDestinationType;
	messagingId?: string;
	warm: boolean;
	transferInitiatorUserId: string;
}
